import type { RefObject } from 'react';

export const getAudioLengthMs = (audioRef: RefObject<HTMLAudioElement>) => {
	if (audioRef.current) {
		const duration = audioRef.current.duration;
		if (isNaN(duration) || duration === Infinity) {
			return 0;
		}

		return Math.floor(duration * 1000);
	}

	return 0;
};

export const getAudioCurrentTimeMs = (audioRef: RefObject<HTMLAudioElement>) => {
	if (audioRef.current) {
		return Math.floor(audioRef.current.currentTime * 1000);
	}

	return 0;
};

export const getAudioProgress = (audioRef: RefObject<HTMLAudioElement>) => {
	if (audioRef.current) {
		const length = getAudioLengthMs(audioRef);
		if (length === 0) {
			return 0;
		}

		return Math.floor((getAudioCurrentTimeMs(audioRef) / length) * 100);
	}

	return 0;
};

export const getClosedEventAttributes = (
	audioRef: RefObject<HTMLAudioElement>,
	reason: string,
) => ({
	audioLengthMs: getAudioLengthMs(audioRef),
	audioCurrentTimeMs: getAudioCurrentTimeMs(audioRef),
	percentCompleted: getAudioProgress(audioRef),
	reason,
});
